module.exports = __webpack_public_path__ + "static/media/connect-the-letters.968ecfe0.png";